import { FC } from "react";

const SVGIconWallapers:FC = () => {
    return(
        <svg width="24px" height="24px" viewBox="0,0,256,256"><g><g transform="scale(10.66667,10.66667)"><path d="M5,3c-1.09306,0 -2,0.90694 -2,2v6h2v-6h6v-2zM13,3v2h6v6h2v-6c0,-1.09306 -0.90694,-2 -2,-2zM15.5,7c-0.82843,0 -1.5,0.67157 -1.5,1.5c0,0.82843 0.67157,1.5 1.5,1.5c0.82843,0 1.5,-0.67157 1.5,-1.5c0,-0.82843 -0.67157,-1.5 -1.5,-1.5zM10.5,12.33203l-3.5,4.66797h10l-2.5,-3.33203l-1.5,2zM3,13v6c0,1.09306 0.90694,2 2,2h6v-2h-6v-6zM19,13v6h-6v2h6c1.09306,0 2,-0.90694 2,-2v-6z"></path></g></g></svg>);
}

export default SVGIconWallapers;